export const BANNER_MIN_HEIGHT_DESKTOP = 340;
